import React, { useCallback, useEffect, useState } from 'react';
import propTypes from 'prop-types';
import {
  TextInput,
  FormGroup
} from '@patternfly/react-core';
import _ from 'lodash';


import SelectV2 from 'components/Select/SelectV2';
import { useTranslation } from '../../localization/useTranslation';
import { TimeUnits, DayUnits, DayUnitsTranslation, TimeUnitsTranslation } from '../../services/constants';
import { getRelativeDate } from './utils';

const timeUnits = _.map(TimeUnitsTranslation, (text, value) => ({ text, value }));
const dayUnits = _.map(DayUnitsTranslation, (text, value) => ({ text, value }));

export const CustomRelativeInput = ({ onTimeSpanChange }) => {
  const T = useTranslation();
  const [relativeData, setRelativeData] = useState({
    lastNumber: 0,
    unit: TimeUnits.MINUTE,
    relativeTo: DayUnits.TODAY,
    hours: 0
  });


  useEffect(() => {
    const timeSpan = getRelativeDate(relativeData);
    onTimeSpanChange(timeSpan);
  }, [onTimeSpanChange, relativeData]);

  const handleRelativeHourChange = useCallback((e) => {
    setRelativeData((prev) => ({
      ...prev,
      hours: e
    }));
  }, [setRelativeData]);


  const handleLastValueChange = useCallback((e) => {
    setRelativeData((prev) => ({
      ...prev,
      lastNumber: e
    }));
  }, [setRelativeData]);

  return (
    <div style={{ zIndex: '1' }}>
      <div className="relative-input-wrapper">
        <FormGroup fieldId="lastNumber" label={T.common.last}>
          <div className="flex">
            <TextInput
              isRequired
              type="number"
              id="lastNumber"
              name="lastNumber"
              aria-describedby="lastNumber-helper"
              value={relativeData.lastNumber}
              className="relative-input-width"
              onChange={(_event, textValue) => handleLastValueChange(textValue)}
            />
            <div className="relative-unit-select-wrapper">
              <SelectV2
                value={relativeData.unit}
                onChange={(e) => setRelativeData((prev) => ({ ...prev, unit: e }))}
                options={timeUnits}
              />
            </div>
          </div>
        </FormGroup>
      </div>

      <div className="form-wrapper" >
        <FormGroup fieldId="relativeTo" label={T.common.relativeTo}>
          <div className="flex">
            <div className="relative-input-width">
              <SelectV2
                value={relativeData.relativeTo}
                onChange={(e) => setRelativeData((prev) => ({ ...prev, relativeTo: e }))}
                options={dayUnits}
              />
            </div>
            <TextInput
              type="number"
              id="relativeHours"
              name="relativeHours"
              value={relativeData.hours}
              className="relative-unit-select-wrapper"
              placeholder="hh"
              onChange={(_event, textValue) => handleRelativeHourChange(textValue)}
            />
          </div>
        </FormGroup>
      </div>
    </div>
  );
};

export default CustomRelativeInput;

CustomRelativeInput.propTypes = {
  onTimeSpanChange: propTypes.func
};
